import { createAction } from "@reduxjs/toolkit";

export const setWebRtc = createAction("webRtc/setWebRtc");
